import { authInterceptor } from './services/interceptors/auth.interceptor';
import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideClientHydration, withHttpTransferCacheOptions } from '@angular/platform-browser';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideToastr } from 'ngx-toastr';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideNgxMask } from 'ngx-mask';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

import { routes } from './app.routes';

const isPublicCacheableGet = (url: string): boolean => {
  const rotasPublicas = [
    'v1/eventos-apresentacao',
    'v1/eventos/',
    'v1/eventos-compartilhamento/',
    'v1/materias',
    'v1/treinos',
    '/assets/i18n/'
  ];

  return rotasPublicas.some((rota) => url.includes(rota));
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideClientHydration(
      withHttpTransferCacheOptions({
        filter: (req) =>
          req.method === 'GET' &&
          (!req.headers.has('Authorization') || isPublicCacheableGet(req.url))
      })
    ),
    provideHttpClient(withFetch(), withInterceptors([authInterceptor])),
    provideAnimations(),
    provideToastr(),
    provideNgxMask(),
    ...provideTranslateService({
      lang: 'pt',
      fallbackLang: 'pt'
    }),
    ...provideTranslateHttpLoader({
      prefix: '/assets/i18n/',
      suffix: '.json'
    })
  ]
};
